export const protocol = 'https';
export const host = 'dev.api.explainlifeinsurance.com';
export const port = '';
export const trailUrl = '';
// export const protocol = "http";
// export const host = "192.168.29.20";
// export const port = "";
// export const trailUrl = "";
